import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../apiCalls/user";
import { verifyEmail, verifyOtp } from "../apiCalls/user";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isFetching, error } = useSelector((state) => state.user);

  const [otp, setOtp] = useState("");
  const initialValues = {
    username: "",
    email: "",
    password: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [otpField, setOtpField] = useState(false);
  const [regField, setRegField] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const verifyMail = async () => {
    let obj = {
      email: formValues.email,
    };
    const res = await verifyEmail(obj, successVerification);
    if (res?.data?.success === true) {
      setOtpField(!otpField);
      toast.success(`🦄 ${res.data.message}`);
    }
  };

  const resendOtp = async () => {
    let obj = {
      email: formValues.email,
    };
    const res = await verifyEmail(obj, successVerification);
    if (res?.data?.success === true) {
      toast.success(`🦄 ${res.data.message}`);
    }
  };

  const successVerification = (res) => {
    toast.error(`🦄 ${res}`);
  };

  const submitOTp = async () => {
    console.log("RUN FOR SUBMIT OTP");
    try {
      let obj = {
        email: formValues.email,
        Otp: otp,
      };
      const res = await verifyOtp(obj);
      if(res.data.success === true) {
        toast.success(`🦄 ${res.data.message}`);
        setRegField(!regField);
        setOtpField(!otpField);
      }
    } catch (err) {
      console.log(err?.response?.data?.err, "err at submit otp");
      toast.error(`🦄 ${err?.response?.data?.err}`);
    }
  };

  const handleClick = () => {
    register(
      dispatch,
      {
        username: formValues.username,
        email: formValues.email,
        password: formValues.password,
      },
      callback
    );
  };

  const callback = (res) => {
    console.log(res, "call back res");
    if(res === 'Registered Succesfullly'){
      toast.success(`🦄 ${res}`);
      navigate("/login");
    }else{
      toast.error(`🦄 ${res}`);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (
      !/^[a-z A-Z0-9]+$/.test(values.username) ||
      /^[ ]+$/.test(values.username)
    ) {
      errors.username = "Name is not valid";
    }

    if (!values.username) {
      errors.username = "Name is Required";
    }

    //email
    if (!values.email) {
      errors.email = "Mail Required";
    }
    if (!regex.test(values.email) && values.email) {
      errors.email = "Invalid Mail";
    }

    if (!values.password) {
      errors.password = "Password is Required";
    }

    if (values.password.length < 8) {
      errors.password = "Minimum password limit is 8";
    }

    return errors;
  };

  useEffect(() => {
    console.log("i am hitting again baby");
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      console.log("runn");
      handleClick();
    }
  }, [formValues, formErrors]);

  return (
    <>
      <section className="login-section">
        <div className="form-wrapper">
          <h2>CREATE AN ACCOUNT</h2>
          <div className="form">
            <div className="form-input">
              <input
                placeholder="Enter Email*"
                name="email"
                value={formValues.email}
                readOnly={regField ? true: false}
                onChange={handleChange}
                autoComplete="off"
              />
              <div className="mail-texts">
                <span className="error_msg text-red">{formErrors.email}</span>
              </div>
              {otpField ? (
                <div className="mail-verification-box">
                  <OtpInput
                    value={otp}
                    inputType="number"
                    onChange={setOtp}
                    numInputs={4}
                    inputStyle={{
                      minWidth: 40,
                      width: 40,
                      margin: "0 12px",
                      padding: 16,
                    }}
                    renderSeparator={<span> </span>}
                    renderInput={(props) => <input {...props} />}
                  />
                  <p className="verify-mail submit-otp" onClick={resendOtp}>
                  Resend OTP
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>

            {regField ? (
              <>
                <div className="form-input">
                  <input
                    placeholder="Enter Full name*"
                    name="username"
                    value={formValues.username}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  <span className="error_msg text-red">
                    {formErrors.username}
                  </span>
                </div>
                <div className="form-input">
                  <input
                    type="password"
                    placeholder="Enter Password*"
                    name="password"
                    value={formValues.password}
                    onChange={handleChange}
                  />
                  <span className="error_msg text-red">
                    {formErrors.password}
                  </span>
                </div>
              </>
            ) : (
              ""
            )}

            <span className="agreement">
              By creating an account, I consent to the processing of my personal
              data in accordance with the <Link to="/">PRIVACY POLICY</Link>
            </span>
           
           {
            !otpField && !regField && <button className="btn bg-warning w-100 br-2" onClick={verifyMail}>
            Verify your email
          </button>
           }
            {otpField ? (
              <button className="btn bg-success w-100 br-2" onClick={submitOTp}>
                submit otp
              </button>
            ) : (
              ""
            )}
            {regField ? (
              <button className="btn w-100 br-2" onClick={handleSubmit}>
                CREATE Account
              </button>
            ) : (
              ""
            )}

            {/* <p>{error}</p> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Register;
